export default defineNuxtRouteMiddleware(async (to, from) => {
  const LOGIN_PATH = `/login`
  const { isAuthenticated, isGuestUser } = useAuth()
  const { mutateAsync: loginGuest } = useGuestLogin()

  if (!isAuthenticated() && to.path !== LOGIN_PATH) {
    if (to.path === '/') {
      await loginGuest()
      return
    }
    return navigateTo(
      `${LOGIN_PATH}?redirect=${encodeURIComponent(from.fullPath)}`,
    )
  }

  if (isGuestUser.value) {
    if (to.path === '/') {
      return
    } else if (to.path !== LOGIN_PATH) {
      return navigateTo(
        `${LOGIN_PATH}?redirect=${encodeURIComponent(to.fullPath)}`,
      )
    }
  }
})
